<div class='advertising mat-elevation-z4'>
  <h1>InterSystems Cloud Services</h1>
</div>

<app-subscriptions [activeSubscriptions]="activeSubscriptions" [inactiveSubscriptions]="inactiveSubscriptions"
  [user]="user" (request)="onRequestAccess($event)" (subscribe)="onSubscribe($event)" (trial)="onTrial($event)"
  (createDeployment)="onCreateDeployment($event)">
</app-subscriptions>